export enum EOCEmailType {
  NewSurgeryEmail,
  NewEOCEmail,
}
